
<div class="filters-wrapper">
  <nb-radio-group name="filter"
    class="filters-container"
    [(ngModel)]="filter"
    (click)="filterChanged()"
    >
    @for (option of filterOptions; track option) {
      <nb-radio [value]="option.value">
        {{ option.label }}
      </nb-radio>
    }
  </nb-radio-group>
</div>
